<div #agGridListviewRef class="card-body table-area list-view">
  <tabset #tabsetRef>
    <tab
      *ngFor="let currentTab of listViewTabConfigs; let i = index"
      [heading]="currentTab.title | translate"
      [id]="currentTab.tabLayer.url"
      [active]="currentTab.position === 0"
      (selectTab)="onSelectTab($event)"
    >
      <ag-grid-server-side
        class="ag-grid"
        [tabIndex]="i"
        [tabID]="currentTab.tabLayer.url"
        [orderByFields]="currentTab.orderByFields"
        [fitColumnsSize]="currentTab.fitColumnsSize"
        [hasGeometry]="currentTab.hasGeometry"
      >
      </ag-grid-server-side>
    </tab>
  </tabset>
</div>
